import { defineStore } from "pinia";

import { useEntityStore } from "@/shared";

import { getShifts } from "../api/getShifts";

export const useShiftsStore = defineStore("shifts", () => {
    const { isManyLoading, manyError, listData, meta, fetchMany } =
        useEntityStore({
            getEntities: getShifts,
        });

    return {
        // entity
        listData,
        meta,
        isManyLoading,
        manyError,
        fetchMany,
    };
});
